// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federpruefung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federpruefungDE: PageEntry = {
  id: "post.federpruefung",
  locale: "de",
  slug: "federpruefung",
  seo: {
    title: "Glossar: Federprüfung einfach erklärt | Dietz GmbH",
    description: "Die Federprüfung ist der Prozess, bei dem Federn auf ihre mechanischen Eigenschaften und ihre Einhaltung von Normen und Spezifikationen getestet werden. Dies kann durch verschieden",
  },
  type: "post",
  h1: "Glossar: Federprüfung einfach erklärt",
  intro: "Die Federprüfung ist der Prozess, bei dem Federn auf ihre mechanischen Eigenschaften und ihre Einhaltung von Normen und Spezifikationen getestet werden. Dies kann durch verschiedene Prüfverfahren wie Belastungstests, Härteprüfungen oder zerstörungsfreie Prüfungen erfolgen. Die Federprüfung ist entscheidend, um sicherzustellen, dass die Federn den Anforderungen ihrer spezifischen Anwendung entsprechen und die geforderte Leistung erbringen. Qualitätskontrollen und Prüfzertifikate sind häufige Ergebnisse von Federprüfungen, die die Zuverlässigkeit und Sicherheit von Federn in verschiedenen Branchen gewährleisten.",
  blocks: [

  ],
};
